export const blockquote = (text: string) => `<blockquote>${text}</blockquote>`
